/**
 * Created by CCristi <ccovali@mitocgroup.com> on 12/11/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AbstractFsDriver = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _AbstractDriver2 = require('./AbstractDriver');

var _crypto = require('crypto');

var _crypto2 = _interopRequireDefault(_crypto);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Abstract FileSystem Driver
 */
let AbstractFsDriver = exports.AbstractFsDriver = function (_AbstractDriver) {
  _inherits(AbstractFsDriver, _AbstractDriver);

  /**
   * @param {String} directory
   */
  function AbstractFsDriver() {
    let directory = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : AbstractFsDriver.DEFAULT_DIRECTORY;

    _classCallCheck(this, AbstractFsDriver);

    var _this = _possibleConstructorReturn(this, (AbstractFsDriver.__proto__ || Object.getPrototypeOf(AbstractFsDriver)).call(this));

    _this._directory = directory;
    return _this;
  }

  /**
   * @param {String} key
   * @returns {String}
   * @private
   */


  _createClass(AbstractFsDriver, [{
    key: '_buildKey',
    value: function _buildKey(key) {
      return `${this._directory}/${AbstractFsDriver._hash(key, 'sha1')}.${AbstractFsDriver._hash(key, 'md5')}`;
    }

    /**
     * @param {String} text
     * @param {String} alg
     * @returns {String}
     * @private
     */

  }], [{
    key: '_hash',
    value: function _hash(text, alg) {
      return _crypto2.default.createHash(alg).update(text).digest('hex');
    }

    /**
     * @returns {Number}
     */

  }, {
    key: '_now',
    get: function get() {
      return parseInt(new Date().getTime() / 1000);
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'DEFAULT_DIRECTORY',
    get: function get() {
      return '__cache__';
    }
  }]);

  return AbstractFsDriver;
}(_AbstractDriver2.AbstractDriver);


//////////////////
// WEBPACK FOOTER
// ../~/deep-cache/lib.compiled/Driver/AbstractFsDriver.js
// module id = 157
// module chunks = 0